import axios from '@axios';

export default {
  namespaced: true,
  state: {
    items: [],
    current: null,
    conditions: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(event => ({
        value: event.code,
        label: event.description,
        related_events: event.related_events
      }))
    },
    getCurrent(state) {
      return state.current
    },
    getConditions(state) {
      return state.conditions
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setCurrent(state, value) {
      state.current = value
    },
    setConditions(state, value) {
      state.conditions = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/dmp/composite-alarm-rules', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },

    async getOne({ commit }, id) {
      const { data } = await axios.get(`v1/dmp/composite-alarm-rules/${id}`)

      if (!data) {
        return null
      }

      commit('setCurrent', data.data)
      return data.data
    },

    async create({ commit }, payload) {
      const { data } = await axios.post('v1/dmp/composite-alarm-rules', payload)

      return data
    },

    async update({ commit }, { id, payload }) {
      const { data } = await axios.put(`v1/dmp/composite-alarm-rules/${id}`, payload)

      return data
    },

    async remove({ commit }, id) {
      const { data } = await axios.delete(`v1/dmp/composite-alarm-rules/${id}`)

      return data
    },

    async getConditions({ commit }, ruleId) {
      const { data } = await axios.get(`v1/dmp/composite-alarm-rules/${ruleId}/conditions`)

      if (!data) {
        return []
      }

      commit('setConditions', data.data)
      return data.data
    },

    async addConditions({ commit }, { ruleId, conditions }) {
      const { data } = await axios.post(`v1/dmp/composite-alarm-rules/${ruleId}/conditions`, { conditions })

      return data
    },

    async replaceConditions({ commit }, { ruleId, conditions }) {
      const { data } = await axios.put(`v1/dmp/composite-alarm-rules/${ruleId}/conditions`, { conditions })

      return data
    },

    async removeCondition({ commit }, { ruleId, conditionId }) {
      const { data } = await axios.delete(`v1/dmp/composite-alarm-rules/${ruleId}/conditions/${conditionId}`)

      return data
    },

    clear({ commit }) {
      commit('setData', [])
      commit('setCurrent', null)
      commit('setConditions', [])
    }
  },
}